import react from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import CoachRouter from "./CoachRouters";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<CoachRouter />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
